import { FC } from 'react';
import { Button } from '@base/lib/Button';
import { RouteEnum } from 'pro/config/routers';
import site from 'pro/config/site';
import { assets } from 'pro/config/assets';
import Image from '@base/lib/ThemeImage';
import { HeaderCart } from '@app/common/PageHeader/HeaderCart';

const ContactIcon: FC<{ icon: string; }> = ({ icon }) => (
    <Image
        width={20}
        height={18}
        src={icon}
        fit={'contain'}
        background={false}
        fixed
        pure
    />
)

export const HeaderWidgets: FC = () => {
    return (
        <>
            <Button
                href={RouteEnum.LIGHT_PLAN}
                size={'small'}
                className={'mr-12'}
            >
                <span className={'text-normal'}>GET A LIGHT PLAN</span>
            </Button>
            <Button
                className={'mr-12'}
                type={'d'}
                href={`tel:${site.contact.phone.url}`}
                size={'small'}
                icon={<ContactIcon icon={assets.tel}/>}
            />
            <Button
                className={'mr-12'}
                type={'d'}
                href={`mailto:${site.contact.email.default}`}
                size={'small'}
                icon={<ContactIcon icon={assets.email}/>}
            />
            <HeaderCart/>
            <Button
                href={RouteEnum.ORDERS}
                type={'d'}
                size={'small'}
                icon={<ContactIcon icon={assets.user}/>}
            />
        </>
    )
};
